import script from "./DynamicFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicFilter.vue?vue&type=script&setup=true&lang=js"

import "./DynamicFilter.vue?vue&type=style&index=0&id=295ada7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-295ada7b"]])

export default __exports__